import { socialApi } from './shared';

/** Hand-authored X / Twitter endpoint copy and examples. */
export const TWITTER = socialApi({
  id: 'x-twitter',
  name: 'X / Twitter',
  skuPrefix: 'twitter',
  blurb:
    'Profiles and tweets from X / Twitter as normalized JSON: pass a handle, get a clean payload back without managing the official API. One key, billed per request in real dollars.',
  endpoints: {
    profile: {
      description: 'Public profile for a handle: name, bio, website, follower/following counts and verification.',
      input: { handle: 'nasa' },
      sample: {
        handle: 'nasa',
        displayName: 'NASA',
        bio: 'There’s space for everybody.',
        location: 'Pale Blue Dot',
        verified: true,
        followers: 79_400_000,
        following: 191,
        tweets: 73_200,
        createdUtc: 1_198_095_641,
        avatarUrl: 'https://pbs.twimg.com/nasa.jpg',
        website: 'https://www.nasa.gov/',
      },
    },
    user_tweets: {
      description: 'Paginated timeline of a user’s tweets with text, media and engagement counts. Paginate with the cursor field.',
      input: { handle: 'nasa', cursor: '0' },
      sample: {
        nextCursor: 'DAABCgABF__cursor',
        tweets: [
          {
            id: '1800000000000000000',
            url: 'https://x.com/NASA/status/1800000000000000000',
            text: 'Liftoff! 🚀',
            likes: 142_000,
            retweets: 21_400,
            replies: 3_900,
            createdAt: '2024-06-09T13:45:00Z',
          },
        ],
      },
    },
    tweet: {
      description: 'Full detail for a single tweet by URL: text, author id, and engagement counts (likes, retweets, replies, quotes, bookmarks, views).',
      input: { url: 'https://x.com/NASA/status/1800000000000000000' },
      sample: {
        id: '1800000000000000000',
        text: 'Liftoff! 🚀',
        authorId: '11348282',
        likes: 142_000,
        retweets: 21_400,
        replies: 3_900,
        quotes: 1_200,
        bookmarks: 8_600,
        views: 9_400_000,
        createdUtc: 1_717_940_700,
      },
    },
  },
});
